import { gql } from '@apollo/client';

export const SUGGEST_INTERNAL_LINKS = gql`
  query SuggestInternalLinks(
    $title: String!
    $body: String!
    $brandKey: BrandKey!
    $existingLinksLabels: [String]
    $idArticle: String
  ) {
    suggestInternalLinks(
      title: $title
      body: $body
      brandKey: $brandKey
      existingLinksLabels: $existingLinksLabels
      idArticle: $idArticle
    ) {
      url
      relevance
      title
      word
      sentence
      blockKey
    }
  }
`;

export const GET_BODY_WITH_SUGGESTED_LINKS = gql`
  query GetBodyWithSuggestedLinks($body: String!, $links: [LinkInput]!) {
    getBodyWithSuggestedLinks(body: $body, links: $links) {
      updatedBody
    }
  }
`;
